import React from 'react';
import { Link } from 'react-router-dom';

class RecipientListPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if ((Object.keys(this.props.schools).length > 0 || Object.keys(this.props.teachers).length > 0) && (window.location.href.indexOf('/marketing/lists/new') == -1 && window.location.href.indexOf('/marketing/mailings/new') == -1)) {
      return (
        <div id="recipientlist_panel" className="animated bounceInUp">
          <h1><i className="fa fa-stream mr-2" />Nuova lista contatti</h1>
          {
            this.props.schools ? (
              <p><span className="recipientlist-panel__number badge badge-light">{Object.keys(this.props.teachers).length }</span> {Object.keys(this.props.teachers).length == 1 ? 'insegnante' : 'insegnanti'}</p>
            ) : ''
          }
          {
            this.props.teachers ? (
              <p><span className="recipientlist-panel__number badge badge-light">{Object.keys(this.props.schools).length }</span> {Object.keys(this.props.schools).length == 1 ? 'scuola' : 'scuole'}</p>            ) : ''
          }

          <p className="text-right">
            <a href="javascript:void(0);" onClick={this.props.onRemoveAllRecipients} className="btn btn-light mr-2">Cancella</a>
            <Link to="/marketing/lists/new/" className="btn btn-primary">Vai a salvataggio <i className="fa fa-arrow-right" /></Link>
          </p>
        </div>
      );
    } else {
      return '';
    }
  }
}

export default RecipientListPanel;


// WEBPACK FOOTER //
// ./src/components/shared/RecipientListPanel.js